module.exports = __webpack_public_path__ + "media/referral/giftbox_icon-652d885a.svg";